import axios from 'axios'
const API = axios.create({baseURL: 'http://localhost:5010'})

export const logIn = (token) => API.get(`/auth/login?token=${token}`)